import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

import { backendApiUrls } from '@app/services/api/api.service';
import { throwSentryError } from '@app/utils/sentry';

export const sentryHttpInterceptor: HttpInterceptorFn = (req, next) => {
  if (!backendApiUrls.has(req.url)) {
    return next(req);
  }

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && shouldReportHttpError(error.status)) {
        const { operation, variables } = getGraphqlInfo(req.body);

        throwSentryError(`http_error: ${error.status} ${operation || req.url}`, {
          method: req.method,
          url: req.url,
          status: error.status,
          statusText: error.statusText,
          message: error.message,
          operation,
          variables,
          response: error.error as unknown,
        });
      }

      return throwError(() => error);
    }),
  );
};

/** Status 0 = aborted/offline; 401 = expired/missing auth — expected noise. */
function shouldReportHttpError(status: number) {
  return status !== 0 && status !== 401;
}

function getGraphqlInfo(body: unknown) {
  if (!body || typeof body !== 'object') {
    return { operation: undefined, variables: undefined };
  }

  const { query, variables } = body as { query?: unknown; variables?: unknown };
  const operation =
    typeof query === 'string'
      ? query.match(/^\s*(?:query|mutation|subscription)\s+(\w+)/)?.[1]
      : undefined;

  return { operation, variables };
}
